'use client';
import React, { useState } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';

const testimonials = [
  {
    id: 'review-001',
    name: 'Adaeze Nwosu',
    role: 'Small Business Owner, Enugu',
    text: 'DakaPay has completely changed how I handle payments. I used to spend hours at the bank. Now I pay all my bills in minutes from my phone. The speed is unmatched!',
    rating: 5,
    initials: 'AN',
  },
  {
    id: 'review-002',
    name: 'Babatunde Adeyemi',
    role: 'Software Engineer, Lagos',
    text: 'The virtual card feature is a game changer for me. I use it for all my international subscriptions — Netflix, AWS, Figma. No stress with dollar payments anymore.',
    rating: 5,
    initials: 'BA',
  },
  {
    id: 'review-003',
    name: 'Fatima Abdullahi',
    role: 'Teacher, Kano',
    text: 'I love how easy the data subscription is. I can buy data for my family members all at once. The prices are much better than going to a vendor.',
    rating: 5,
    initials: 'FA',
  },
  {
    id: 'review-004',
    name: 'Emeka Okafor',
    role: 'Trader, Onitsha',
    text: 'Been using DakaPay for 8 months now. Never had a failed transaction. Customer support is always available. This is the best fintech app in Nigeria.',
    rating: 5,
    initials: 'EO',
  },
  {
    id: 'review-005',
    name: 'Ngozi Eze',
    role: 'Nurse, Abuja',
    text: 'Paying my AEDC electricity bill used to take 30 minutes. Now it takes 30 seconds with DakaPay. I get my token immediately. Highly recommend!',
    rating: 5,
    initials: 'NE',
  },
  {
    id: 'review-006',
    name: 'Seun Ajayi',
    role: 'Content Creator, Ibadan',
    text: 'The referral program is amazing. I\'ve earned over ₦15,000 just by referring friends. Plus the app is super easy to use. 10/10!',
    rating: 5,
    initials: 'SA',
  },
];

export default function Testimonials() {
  const [page, setPage] = useState(0);
  const perPage = 3;
  const totalPages = Math.ceil(testimonials?.length / perPage);
  const visible = testimonials?.slice(page * perPage, page * perPage + perPage);

  return (
    <section className="py-20 bg-muted/40" id="testimonials">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="text-accent text-sm font-600 uppercase tracking-widest">Customer Reviews</span>
          <h2 className="text-3xl md:text-4xl font-700 text-primary mt-2 mb-4">
            Loved by Nigerians Everywhere
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {visible?.map((review) => (
            <div key={review?.id} className="bg-card rounded-2xl p-6 border border-border shadow-card service-card-hover">
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: review?.rating })?.map((_, i) => (
                  <Star key={`star-${review?.id}-${i}`} size={14} className="fill-amber-400 text-amber-400" />
                ))}
              </div>
              <p className="text-muted-foreground text-sm leading-relaxed mb-5">"{review?.text}"</p>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full gradient-card flex items-center justify-center text-white text-xs font-700 shrink-0">
                  {review?.initials}
                </div>
                <div>
                  <p className="text-sm font-600 text-foreground">{review?.name}</p>
                  <p className="text-xs text-muted-foreground">{review?.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-center gap-3">
          <button
            onClick={() => setPage(Math.max(0, page - 1))}
            disabled={page === 0}
            className="w-9 h-9 rounded-full border border-border bg-card flex items-center justify-center text-muted-foreground hover:text-foreground hover:border-primary disabled:opacity-30 transition-all"
          >
            <ChevronLeft size={16} />
          </button>
          {Array.from({ length: totalPages })?.map((_, i) => (
            <button
              key={`tpage-${i}`}
              onClick={() => setPage(i)}
              className={`w-2.5 h-2.5 rounded-full transition-all ${i === page ? 'bg-accent w-6' : 'bg-border'}`}
            />
          ))}
          <button
            onClick={() => setPage(Math.min(totalPages - 1, page + 1))}
            disabled={page === totalPages - 1}
            className="w-9 h-9 rounded-full border border-border bg-card flex items-center justify-center text-muted-foreground hover:text-foreground hover:border-primary disabled:opacity-30 transition-all"
          >
            <ChevronRight size={16} />
          </button>
        </div>
      </div>
    </section>
  );
}